/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useRef, useState } from 'react';
import { cardContenttype, cardDataExtractorUtil, isClipVideo } from '../mutvutil';
import MutvCards from '../Cards/MutvCards';
import Loader from '../../Common/Loader';
import Slider from 'react-slick';
import {
  afterChangeAccessbility,
  beforeChangeAccessbility,
  onInitAccessibility,
  NextArrow,
  PrevArrow,
  slideShowCount,
} from '../../../utils/carouselUtils';
import MU from '../../../constants/muConstants';
import { useSponsorValue } from '../../../context/sponsorContext';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-react';
import { checkDevice } from '../../../utils/utils';

const CarouselMyListListing = (props) => {
  const {
    cardData,
    listView,
    status,
    showLoadMore,
    inlinePlay,
    dispatch,
    initialLoad,
    containerType,
    isContinueCard,
    showDeleteBtn,
    onDeleteItem,
    idsToDeletes,
    mylistPage,
    isMutvMovie,
    isDetailsListView,
    newLoadMore,
  } = props;
  const [
    { isLoginChecked, userLoginDetail, isUserLogin, isUserSubscribe, isUserSkyId },
  ] = useSponsorValue();
  const [page, setPage] = useState(0);
  const infiniteScroll = useRef(null);
  const refElement = useRef(null);
  const [slicker, setSlicker] = useState({});
  const [screenReaderText, setScreenReaderText] = useState('');
  const [isTouchDevice, setIsTouchDevice] = useState(true);
  useEffect(() => {
    setIsTouchDevice(checkDevice());
  }, []);
  useEffect(() => {
    var options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };
    const observer = new IntersectionObserver(handleObserver, options);
    if (infiniteScroll.current) {
      observer.observe(infiniteScroll.current);
    }
    return () => {
      infiniteScroll.current && observer.unobserve(infiniteScroll.current);
    };
  }, []);

  useEffect(() => {
    if (page && isDetailsListView && showLoadMore && status !== 'fetching') {
      newLoadMore();
    }
  }, [page]);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setPage((page) => page + 1);
    }
  };

  const slideCount = () => {
    if (cardData.length > 0) {
      return cardData.length;
    } else {
      return 0;
    }
  };
  const setScreenReaderValue = (index) => {
    const a = index;
    const b = slideShowCount();
    const c = slideCount();
    if (a + b <= c) {
      setScreenReaderText(`Displayed ${a + 1} of ${a + b} out of ${c}`);
    }
    setTimeout(() => {
      setScreenReaderText('');
    }, 300);
  };
  const nextPrevArrow = (oldIndex, newIndex, slicker, bypass) => {
    setTimeout(() => {
      if (oldIndex < newIndex || bypass) {
        slicker && slicker.prevArrow && slicker.prevArrow.classList.remove('clicked');
        slicker && slicker.nextArrow && slicker.nextArrow.classList.add('clicked');
      }
      if (oldIndex > newIndex) {
        slicker && slicker.prevArrow && slicker.prevArrow.classList.add('clicked');
        slicker && slicker.nextArrow && slicker.nextArrow.classList.remove('clicked');
      }
    }, 100);
  };
  const settings = () => {
    return {
      className: 'carousal-list center',
      lazyLoad: 'progressive',
      variableWidth: true,
      infinite: false,
      speed: 400,
      dots: true,
      slidesToScroll: slideShowCount(),
      swipe: true,
      accessibility: false,
      slidesToShow: slideShowCount(),
      draggable: false,
      // swipeToSlide: true,
      touchMove: true,
      mobileFirst: true,
      touchThreshold: 20,
      initialSlide: 0,
      rtl: false,
      arabic: MU.language === 'ar' ? true : false,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow slideShow={slideShowCount()} />,
      appendDots: (dots) => {
        if (dots && dots.length) {
          let isActive = true;
          let list = dots.map((val, index) => {
            isActive = isActive ? val.props.className !== 'slick-active' : false;
            return (
              <li key={index} className={`${val.props.className} ${isActive ? 'active' : ''}`}>
                <i></i>
              </li>
            );
          });
          return (
            <div className="slick-dots">
              <ul tabIndex="-1" aria-hidden="true">
                {list}
              </ul>
            </div>
          );
        }
      },
      onLazyLoad: (e) => {
        if (e.includes(slideCount() - 1)) {
          setTimeout(() => {
            if (refElement) {
              const slider = refElement && refElement.current;
              let list = slider && slider.querySelector('.slick-list');
              let slideTrack = list && list.querySelector('.slick-track');
              let slides = slideTrack && slideTrack.querySelectorAll('.slick-slide');
              let nextArrow = slider && slider.querySelector('.slider-next.slick-arrow');
              let prevArrow = slider && slider.querySelector('.slider-prev.slick-arrow');
              onInitAccessibility(slideTrack, slides, 'myList');
              setSlicker({
                slider: slider,
                list: list,
                track: slideTrack,
                slides: slides,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
              });
            }
          }, 500);
        }
      },
      beforeChange: (oldIndex, newIndex) => {
        setScreenReaderValue(newIndex);
        nextPrevArrow(oldIndex, newIndex, slicker);
        beforeChangeAccessbility(slicker, 'myList');
      },
      afterChange: () => {
        afterChangeAccessbility(slicker);
      },
    };
  };

  const renderCards = (aspectRatio, index, item) => {
    if (item && cardContenttype.includes(item.contenttype_t && item.contenttype_t.toLowerCase())) {
      return (
        <div className="filterCards">
          {item && (
            <MutvCards
              containerType={containerType}
              carouselContentType={item.contenttype_t}
              cardAspectRatio={aspectRatio ? aspectRatio : '4x3'}
              gridClass="grid-3"
              key={index}
              item={item}
              inlinePlay={inlinePlay ? true : false}
              isUserLogin={isUserLogin}
              isLoginChecked={isLoginChecked}
              userLoginDetail={userLoginDetail}
              dispatch={dispatch}
              isUserSubscribe={isUserSubscribe}
              isUserSkyId={isUserSkyId}
              isContinueCard={isContinueCard}
              showDeleteBtn={showDeleteBtn}
              onDeleteItem={onDeleteItem}
              isDeleteChecked={idsToDeletes && idsToDeletes.find((val) => val === item.itemid_s)}
              mylistPage={mylistPage}
              isMutvMovie={isMutvMovie}
            />
          )}
        </div>
      );
    } else {
      return null;
    }
  };
  return (
    <React.Fragment>
      <div className={`mutv-shows__filter-data ${listView ? 'row-pattern' : ''}`} tabIndex="none">
        <div className="mutv-shows__items carousalView" tabIndex="none">
          {isDetailsListView ? (
            <div className="home-row detailsListView">
              {cardData?.map((item, index) => {
                return renderCards(props.aspectRatio, index, item);
              })}
            </div>
          ) : (
            cardData?.length > 0 && (
              <div className="home-row">
                {!isTouchDevice && !isExperienceEditorActive() && (
                  <div className="carousal">
                    <Slider {...settings()}>
                      {cardData.slice(0, 8).map((item, index) => {
                        return renderCards(props.aspectRatio, index, item);
                      })}
                    </Slider>
                  </div>
                )}
                {(isTouchDevice || isExperienceEditorActive()) && cardData?.length > 0 && (
                  <div className="carousal-wrapper">
                    <div className="carousal-list custom-mobile-slider">
                      {cardData.map((item, index) => {
                        return (
                          <div className="mobile-listitem" role="listitem" key={index}>
                            {renderCards(props.aspectRatio, index, item)}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )
          )}
          {status === 'fetching' && (
            <div
              className="loader-carouselListing__wrapper"
              style={initialLoad ? { paddingTop: '70px' } : null}
            >
              <Loader className="loader-carouselListing" />
            </div>
          )}
        </div>
      </div>
      <div
        className="infinite_Scroll"
        style={{ display: 'inline-block', position: 'relative' }}
        ref={infiniteScroll}
      >
        {isDetailsListView && showLoadMore && status !== 'fetching' && (
          <button style={{ visibility: 'hidden' }} />
        )}
      </div>
    </React.Fragment>
  );
};
CarouselMyListListing.defaultProps = {
  inlinePlay: false,
};
export default CarouselMyListListing;
